import React from "react";
import {
  Box,
  Typography,
  CardContent,
  LinearProgress,
  Divider,
} from "@mui/material";
import { StyledCard } from "../../common/StyledCard";
import { getEntityMeta } from "../../../helpers/dashboardHelpers";
import { formatCurrency } from "../../../utils/currencyUtils";
import { CreditNoteStatsDto } from "../../../shared/dtos/creditNote/CreditNoteStatsDto";

interface CreditNoteWidgetProps {
  data: CreditNoteStatsDto;
}

const CreditNoteWidget: React.FC<CreditNoteWidgetProps> = ({ data }) => {
  const meta = getEntityMeta("CREDIT_NOTE");
  const Icon = meta.icon;

  const safeTotal = data.totalCreditedToday || 1;
  const appliedPercentage = (data.totalAppliedToday / safeTotal) * 100;

  return (
    <StyledCard sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: "flex",
              mr: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Total Value Credited
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: "bold" }}>
            {formatCurrency(data.totalCreditedToday)}
          </Typography>
        </Box>

        <Box>
          <Box
            sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}
          >
            <Typography variant="body2" sx={{ color: "info.main" }}>
              Applied
            </Typography>
            <Typography variant="body2">
              {formatCurrency(data.totalAppliedToday)}
            </Typography>
          </Box>
          <LinearProgress
            variant="determinate"
            value={appliedPercentage}
            color="info"
            sx={{ height: 6, borderRadius: 3 }}
          />
        </Box>

        <Divider sx={{ my: 2 }} />

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Notes Issued
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
            {data.issuedToday}
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  );
};

export default CreditNoteWidget;
